<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<p class="center" id="epigraph"><a id="start">When an inner situation is not made conscious, it happens outside, as fate. When the individual does not become conscious of his inner contradictions, the world must perforce act out the conflict and be torn into opposite halves.</a></p><a id="start">
<p class="right">Carl Jung</p>
</a></blockquote><a id="start">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-epigraph.vue?13bc50b8